module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"location":"Месторасположение","no-cameras":"Камер нет","status":"Статус"},"en":{"location":"Location","no-cameras":"No cameras","status":"Status"}}')
  delete Component.options._Ctor
}
